import * as Option from "@utils/Option";
import type { OptionTs } from "@ps-bridge/interop";

export const requireContext = <A,>(context: OptionTs<A>, message: string): A => {
  const missing = (): A => {
    throw new Error(message);
  };

  return Option.fold(context, missing, (value: A) => value);
};
